import React from 'react';
import { Parser } from 'html-to-react';
import Manager from '@components/Manager';
import { Bubble } from '@components/Organisms/Bubble';
import { BUBBLE_CORNERS } from '@components/Organisms/Bubble/_constants/Bubble.constants';

const Helper = ({ modifier = '', text, manager }) => {
  const htmlParser = new Parser();

  return manager ? (
    <div className={`c-app-helper ${modifier}`}>
      <div className="c-app-helper__user">
        <Manager manager={manager} />
      </div>
      <div className="c-app-helper__message">
        <Bubble
          className="c-app-helper__bubble"
          corner={BUBBLE_CORNERS.TOP_LEFT}
        >
          {htmlParser.parse(text)}
        </Bubble>
      </div>
    </div>
  ) : null;
};

export default Helper;
